(function () {
    'use strict';

    angular.module("imApp").factory("invoiceMethodsService", ['$ihttp', function ($ihttp) {
        let service = {
            listInvoiceMethods: function (parms) {
                return $ihttp.post({
                    method: 1762,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
